import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getWebViewerFeaturePackages() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_feature_packages'
      })
    }
  );
}


// WEBPACK FOOTER //
// ./src/services/webViewerFeaturePackages.js